import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// locales
import tr from "@/locales/tr.json";
import en from "@/locales/en.json";
import ru from "@/locales/ru.json";
import helpCenterTr from "@/locales/helpCenter/tr.json";
import helpCenterEn from "@/locales/helpCenter/en.json";
import helpCenterRu from "@/locales/helpCenter/ru.json";

// messages list
const messages = {
  tr: {
    ...tr,
    helpCenter: helpCenterTr,
  },
  en: {
    ...en,
    helpCenter: helpCenterEn,
  },
  ru: {
    ...ru,
    helpCenter: helpCenterRu,
  },
};
export const AVAILABLE_LOCALES = Object.keys(messages);
export const LOCALE_STORAGE_KEY = "app-locale";

const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);
const initialLocale =
  savedLocale && AVAILABLE_LOCALES.includes(savedLocale) ? savedLocale : "tr";

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: "tr",
  messages,
});

export function setAppLocale(locale) {
  if (!AVAILABLE_LOCALES.includes(locale)) return false;
  i18n.locale = locale;
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  document.documentElement.setAttribute("lang", locale);
  return true;
}

document.documentElement.setAttribute("lang", initialLocale);

export default i18n;
